import PropTypes from 'prop-types';

import { makeonMouseEnterForNonTouchDevices } from 'helpers';
import ProductUtils from 'helpers/ProductUtils';
import css from 'styles/components/productdetail/buyNowButton.scss';

const BuyNowButton = ({ sizing, selectedSizing, colorId, onClick, onShowSelectSizeTooltip, onHideSelectSizeTooltip, mouseEnterFactory }, { testId }) => {
  let onHand = 1, stockId;
  if (ProductUtils.isSizeSelectionComplete(sizing, selectedSizing)) {
    const stock = ProductUtils.getStockBySize(sizing.stockData, colorId, selectedSizing);
    if (stock) {
      stockId = stock.id;
      onHand = parseInt(stock.onHand, 10);
    } else {
      onHand = 0; // size select is complete, but we never had a stockId for this size/color combo
    }
  }
  const showTooltipHandler = mouseEnterFactory(onShowSelectSizeTooltip);
  return (
    <div className={css.container}>
      <button
        type="button"
        onClick={onClick}
        data-test-id={testId('buyNow')}
        data-stock-id={stockId}
        disabled={onHand < 1 }
        onMouseEnter={showTooltipHandler}
        onMouseLeave={onHideSelectSizeTooltip}
        onFocus={showTooltipHandler}
        onBlur={onHideSelectSizeTooltip}>buy now</button>
    </div>
  );
};

BuyNowButton.contextTypes = {
  testId: PropTypes.func.isRequired
};

BuyNowButton.defaultProps = {
  mouseEnterFactory: makeonMouseEnterForNonTouchDevices
};

export default BuyNowButton;
